import React from 'react';

// import IconLinkedin from '../Icons/IconLinkedin';
// import IconFacebook from '../Icons/IconFacebook';
// import IconInstagram from '../Icons/IconInstagram';

// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const Footer = () => {


  return (
    <footer className={cn("wrapper")}>
      <div className={cn("container")}>
        <div className={cn("content")}>
          <div className={cn("info")}>
            <div className={cn("logo")}>
              <img src="/logo_white.png" alt="studio bevilacqua logo" loading="lazy" decoding="async" />
            </div>
            <div className={cn("contacts")}>
              <span>Telefono: <a href="tel:+390434208295">+39 0434 208295</a></span>
              <span>Email: <a href="mailto:segreteria@slbf.it">segreteria@slbf.it</a></span>
              <span>Piazza Ellero Enea dei Mille, 6 Pordenone - 33170</span>
            </div>
          </div>
          {/* <div className={cn("social")}>
              <h5>Seguici su</h5>
              <div className={cn("social-links")}>
                <div className={cn('item')}><a href="#"><IconFacebook /></a></div>
                <div className={cn('item')}><a href="#"><IconInstagram /></a></div>
                <div className={cn('item')}><a href="#"><IconLinkedin /></a></div>
              </div>
            </div> */}
        </div>
        <div className={cn("footer")}>
          <div className={cn("data")}>
            <span>© 2021 Studio Bevilacqua</span>
            <span>P.I. 01590090930</span>
          </div>
          <div className={cn("terms")}>
            <a href="/cookie-policy">Cookie Policy</a>
            <a href="/privacy-policy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;